import {useGetLookUps} from 'hooks';
import {LookupCategoryTypes} from 'models';
import React, {useEffect} from 'react';
import {RenderSelect} from '.';
import {FieldsRendererProps} from '../FieldsRenderer';
import {ItemDataFieldModel} from 'models/board';

interface RenderAppEventTriggersSelectProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderAppEventTriggersSelect: React.FC<RenderAppEventTriggersSelectProps> = props => {
    const [updatedField, setUpdatedField] = React.useState<ItemDataFieldModel | undefined>(undefined);
    const {field} = props;
    const {getLookups, getLookupsLoading, getLookupsResponse} = useGetLookUps();
    useEffect(() => {
        getLookups({
            variables: {
                first: 50,
                where: {category: {eq: LookupCategoryTypes.AppEventTrigger}},
            },
        });
    }, []);

    useEffect(() => {
        if (getLookupsResponse && getLookupsResponse.nodes.length > 0) {
            const options = getLookupsResponse.nodes.map(lookup => ({
                label: lookup.title,
                value: lookup.id,
            }));
            setUpdatedField({
                ...field,
                defaultValue: {options},
            });
        }
    }, [getLookupsResponse, field]);

    if (!updatedField) {
        return <></>;
    }
    return <RenderSelect {...props} isLoading={getLookupsLoading} field={updatedField} />;
};
export default RenderAppEventTriggersSelect;
